const embedInMobile = window.navigator.userAgent.match(/fms-mobile/);

export default embedInMobile;
